import { useEffect } from "react";

export default function SEOHead() {
  useEffect(() => {
    document.title = "Calle & Cía. Abogados | Recuperación Judicial de Créditos";
    
    // Update meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute("content", "Calle & Cía. Abogados - Recuperación judicial de créditos morosos para bancos e instituciones financieras en Chile. Más de 25 años de experiencia.");
    }

    // Update theme color
    let themeColor = document.querySelector('meta[name="theme-color"]');
    if (themeColor) {
      themeColor.setAttribute("content", "#1d2e44");
    }
  }, []);

  return null;
}
